import React from 'react';

import { CreditNoteIcon } from '../../Assets/Navigation/NavigationIcons';

import Email from '../../Components/Email/Email';
import { t } from 'i18next';

export default (props) => {
  return (
    <Email
      {...props}
      Icon={CreditNoteIcon}
      name={t('ListTable.credit_note')}
      onCancelURL="/creditnotes"
      emailAPI={`creditnotes/${props.match.params.id}/mail`}
      fetchDataAPI={`creditnotes/${props.match.params.id}/mail`}
      getBackTab
    />
  );
};
